
import * as handlebars_family from "../handlebars_family.js";
import "../mealplanner/recipeListFilter.mustache";
const TPL = handlebars_family.addTemplate("mealplanner/recipeListWidget",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <button class=\"fab\" data-fw-onclick=\"recipepickadd\" title=\""
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.create",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":211},"end":{"line":1,"column":236}}}))
    + "\"><icon>"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_add_plus",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":244},"end":{"line":1,"column":269}}}))
    + "</icon></button> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"main flexcol\" style=\"gap:var(--space)\"> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"mealplanner/recipeListFilter"),depth0,{"name":"mealplanner/recipeListFilter","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " <flexcol class=\"mp-recipe-list\"></flexcol></div> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"quickadd") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":135},"end":{"line":1,"column":293}}})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;